import { UnitRoofElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitRoofElementFormModel';

export type UnitRoofElementResponse = {
  roofElementId: number;
  displayIndex: number;
  name: string;
  roofThermalTransmittance: number | null;
  skylightThermalTransmittance: number | null;
  defaultTemperatureAboveInDegreesCelsius: number | null;
};

export const mapUnitRoofElementResponseToFormModel = (response: UnitRoofElementResponse): UnitRoofElementFormModel => ({
  roofElementId: response.roofElementId,
  name: response.name,
  roofThermalTransmittance: response.roofThermalTransmittance?.toString() ?? '',
  skylightThermalTransmittance: response.skylightThermalTransmittance?.toString() ?? '',
  defaultTemperatureAboveInDegreesCelsius: response.defaultTemperatureAboveInDegreesCelsius?.toString() ?? '',
});
